import { movies } from "@/mocks/movies";
import type { Movie, MovieType } from "@/types/movie";

export const catalog: Movie[] = movies as Movie[];

export interface CategoryMeta {
  key: MovieType;
  label: string;
  english: string;
  description: string;
  icon: string;
}

export const CATEGORIES: CategoryMeta[] = [
  {
    key: "movie",
    label: "电影",
    english: "Movies",
    description: "高分电影、院线新片与经典佳作，高清在线看个够。",
    icon: "ri-film-line",
  },
  {
    key: "tv",
    label: "电视剧",
    english: "TV Series",
    description: "热播剧集、口碑长剧与海外好剧，追剧不错过每一集。",
    icon: "ri-tv-2-line",
  },
  {
    key: "variety",
    label: "综艺",
    english: "Variety",
    description: "真人秀、音乐、美食与竞技综艺，轻松愉快的下饭首选。",
    icon: "ri-mic-line",
  },
];

export function getCategoryMeta(type: string): CategoryMeta | undefined {
  return CATEGORIES.find((item) => item.key === type);
}

export function getByType(type: MovieType): Movie[] {
  return catalog.filter((item) => item.type === type);
}

export function getById(id: string): Movie | undefined {
  return catalog.find((item) => item.id === id);
}

export function getFeatured(): Movie[] {
  return catalog.filter((item) => item.featured);
}

export function getHot(limit = 8): Movie[] {
  return [...catalog].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatest(limit = 8): Movie[] {
  return [...catalog]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, limit);
}

export function getRelated(movie: Movie, limit = 6): Movie[] {
  const sameType = catalog.filter(
    (item) => item.id !== movie.id && item.type === movie.type
  );
  const sameGenre = sameType.filter((item) =>
    item.genres.some((g) => movie.genres.includes(g))
  );
  const rest = sameType.filter((item) => !sameGenre.includes(item));
  return [...sameGenre, ...rest].slice(0, limit);
}

export function searchCatalog(keyword: string): Movie[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return catalog.filter(
    (item) =>
      item.title.toLowerCase().includes(q) ||
      item.summary.toLowerCase().includes(q) ||
      item.genres.some((g) => g.toLowerCase().includes(q)) ||
      item.region.toLowerCase().includes(q)
  );
}

export const REGIONS: string[] = Array.from(
  new Set(catalog.map((item) => item.region))
);

export const YEARS: number[] = Array.from(
  new Set(catalog.map((item) => item.year))
).sort((a, b) => b - a);

export const GENRES: string[] = Array.from(
  new Set(catalog.flatMap((item) => item.genres))
);

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return String(views);
}